import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@root/app.config';
import { Root } from '@shared/components/layout/root/root';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeRuExtra from '@angular/common/locales/extra/ru';
import localeFr from '@angular/common/locales/fr';
import localeRu from '@angular/common/locales/ru';


registerLocaleData(localeRu, 'ru', localeRuExtra);
registerLocaleData(localeEs, 'es', localeEsExtra);
registerLocaleData(localeFr, 'fr', localeFrExtra);

bootstrapApplication(Root, appConfig).catch((err) => console.error(err));
